export default {
    'realtime_revenue': '付费金额({unit})',
    'realtime_revenue_title': '实时收入',
    'realtime_steam_title':'实时Steam销量',
    'realtime_steam_units':'Steam销量',
    'realtime_steam_realtime_steam_title': '每日实时累计Steam销量（1小时）',
    'realtime_revenue_realtime_revenue_title': '每日实时累计付费金额（10分钟）',
    'realtime_revenue_realtime_revenue_chart_title': '每日实时累计付费金额（10分钟）',
    'realtime_revenue_realtime_revenue_download': '每日实时累计付费金额（10分钟）',
    'realtime_revenue_realtime_revenue_Statistical':'统计时间',
    'realtime_revenue_chart_explain':'受midas数据计算及回传时效影响，整体收入数据延迟约40分钟。',
    'realtime_revenue_realtime_revenue_Time':'时间',
    'realtime_info_download_settings': '下载设置',
    'realtime_info_download_by_hour': '下载逐小时数据',
    'realtime_info_download_by_5_min': '下载每5 min数据',
    'realtime_info_download_by_10_min': '下载每10 min数据',
    'realtime_info_download_time': '时间粒度',
    'realtime_info_download_sort': '排序',
    'realtime_info_download_sort_up': '时间升序',
    'realtime_info_download_sort_down': '时间降序',
    'realtime_info_download_metrics': '下载内容',
    'realtime_info_download_metrics_realtime_detail_data': '实时明细数据 (右侧图表)',
    'realtime_info_download_metrics_top_change_by_country': '分国家异动数据 (左侧表格)',
    'realtime_info_download_file_format': '文件格式',
    'realtime_info_steam_chart_explain':'数据来源于Steam后台，Steam平台数据有1小时延迟，另外当前unit数据已剔除第三方销售和激活码激活的情况。',
}
